// @flow

import * as React from 'react';
import { View, Text, Pressable } from 'react-native';
import { Overlay, ThemeContext } from 'react-native-elements';
import memoizeOne from 'memoize-one';
import { BLUE_COLOR } from '../../styles/common';

const styles = memoizeOne(() => ({
    overlay: {
        overflow: 'hidden',
        background: '#fff',
        borderRadius: '20px',
        height: 'auto',
        paddingVertical: 20,
        paddingHorizontal: 50,
        maxWidth: '80%',
        alignItems: 'center',
        margin: '0 auto',
    },
    overlay_container: {
        overflow: 'hidden',
        height: 'auto',
        // maxWidth: '80%',
        color: BLUE_COLOR,
    },
    overlay_title: {
        color: '#757783',

    },
    overlay_buttons_container: {
        marginTop: 25,
        flexDirection: 'row',
        justifyContent: 'space-around',

    },
    button: {
        border: 'none',
        fontSize: '1.5em',
        fontWeight: 300,
        overflow: 'hidden',
    },
    buttonTextStyle: {
        color: BLUE_COLOR,
    },
}));

type Props = {
    visible: boolean,
    onBackdrop: Function,
    text: string,
    buttons: Array<Object>,
};

const OverlayDialog = (props: Props) => {
    const { theme } = React.useContext(ThemeContext);
    const {
        visible, onBackdrop, text, buttons,
    } = props;

    return (
        <Overlay overlayStyle={styles(theme).overlay} isVisible={visible} onBackdropPress={onBackdrop}>
            <View style={styles(theme).overlay_container}>
                <Text style={styles(theme).overlay_title}>{text}</Text>
                <View style={styles(theme).overlay_buttons_container}>

                    {buttons.map((button) => (
                        <Pressable
                            color={BLUE_COLOR}
                            key={button.id}
                            buttonStyle={[styles(theme).button, button.buttonStyle]}
                            onPress={button.onClick}
                            titleStyle={[button.titleStyle]}
                        >
                            <Text style={styles(theme).buttonTextStyle}>
                                {button.text}
                            </Text>
                        </Pressable>
                    ))}
                </View>
            </View>
        </Overlay>
    );
};

export default OverlayDialog;
